import { Api } from "../config/request";

export default {
  getFleetCoachList(body) {
    return Api.post(`/logistics-support/fleet-coach/list`, body);
  },
  getFleetCoachDetails(id) {
    return Api.get(`/logistics-support/fleet-coach/${id}`);
  },
  saveUpdateFleetCoach(body) {
    return Api.post(`/logistics-support/fleet-coach/upsert`, body);
  },
  updateFleetCoachDocument(id, body) {
    return Api.put(`/logistics-support/fleet-coach/${id}/documents`, body);
  },
};
